import { useGetIncomeReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function IncomeReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:income_report')}
      usePivotQuery={useGetIncomeReport}
      completeName={['customer']}
    />
  );
}
